import { useCallback } from 'react';
import { NavigateFunction } from 'react-router';
import { openModalByName } from '@mindtickle/modal/withModal';
import {
  getModuleFromInitalisedRemote,
  isRemoteIntialised,
} from '@mindtickle/ui-shell-core/DynamicRemote';
import { DYNAMIC_REMOTES } from '~/config/app.constants';

type UseSupportActionsParams = {
  navigate: NavigateFunction;
  berryActions?: any;
  isBerryChatDisabled: boolean;
};

type UseSupportActionsReturn = {
  openGetSupport: () => Promise<void>;
};

export default function useSupportActions({
  navigate,
  berryActions,
  isBerryChatDisabled,
}: UseSupportActionsParams): UseSupportActionsReturn {
  const openGetSupport = useCallback(async () => {
    if (!isRemoteIntialised(DYNAMIC_REMOTES.GET_SUPPORT.remoteName)) return;

    const { remoteName, moduleName } = DYNAMIC_REMOTES.GET_SUPPORT;
    const { MODAL_NAME } = await getModuleFromInitalisedRemote(remoteName, moduleName);

    const openFeedbackModal = () => {
      openModalByName(MODAL_NAME, navigate, { stacking: true });
    };

    if (!isBerryChatDisabled && berryActions?.isBerryInitialized?.()) {
      berryActions?.updateSendFeedbackFromBerry?.(openFeedbackModal);
      berryActions?.showBerry?.();
      return;
    }

    openFeedbackModal();
  }, [navigate, berryActions, isBerryChatDisabled]);

  return { openGetSupport };
}
